import { KEY_DOWN } from './constants';

export function checkKeyPressed(event, doFunction) {
  if (event.which === KEY_DOWN.SPACE || event.which === KEY_DOWN.ENTER) {
    return doFunction();
  }
}
